module.exports = require("./kw-GB");